import { inject, Injectable } from '@angular/core';
import { ClientsiteSharedLoggingService } from '@rx-applications/clientsite/core/logging';
import { EventName, LogChannelMessageMappings } from '../models/amplitude-events.enum';

@Injectable({
  providedIn: 'root',
})
export class ClientsiteAdminLoggerService {
  #clientsiteSharedLoggingService = inject(ClientsiteSharedLoggingService);

  landedManageEmployees(): void {
    const event = LogChannelMessageMappings[EventName.LandedManageEmployees];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, event.message);
  }

  landedCustomFields(): void {
    const event = LogChannelMessageMappings[EventName.LandedCustomFields];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, event.message);
  }

  landedCustomFieldValuesPage(): void {
    const event = LogChannelMessageMappings[EventName.LandedOnCustomFieldValuesPage];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, event.message);
  }

  updateUserSettings(props: Record<string, unknown>): void {
    const event = LogChannelMessageMappings[EventName.ChangedUserSettings];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, { ...event.message, props });
  }

  updateWebsiteCustomFieldValue(props: Record<string, unknown>): void {
    const event = LogChannelMessageMappings[EventName.CustomFieldValueUpdate];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, { ...event.message, props });
  }

  updateWebsiteCustomFieldMandatory(props: Record<string, unknown>): void {
    const event = LogChannelMessageMappings[EventName.CustomFieldMandatoryUpdate];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, { ...event.message, props });
  }

  invitationResent(props: Record<string, unknown>): void {
    const event = LogChannelMessageMappings[EventName.InvitationResent];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, { ...event.message, props });
  }

  invitationDeleted(props: Record<string, unknown>): void {
    const event = LogChannelMessageMappings[EventName.InvitationDeleted];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, { ...event.message, props });
  }

  userBulkUploadCompleted(): void {
    const event = LogChannelMessageMappings[EventName.UserBulkUploadCompleted];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, event.message);
  }

  userBulkUploadApplyCompleted(): void {
    const event = LogChannelMessageMappings[EventName.UserBulkUploadApplyCompleted];
    this.#clientsiteSharedLoggingService.sendToPubSub(event.channels, event.message);
  }
}
